/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/propagandists/', params);
}

function get(id, params) {
  return api.get(`/propagandists/${id}`, params);
}

function getStatistics(id, params) {
  return api.get(`/propagandists/${id}/statistics`, params);
}

function create(params) {
  return api.post('/propagandists', params);
}

function update(id, params) {
  return api.put(`/propagandists/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/propagandists/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}


export const propagandistsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  getStatistics,
};
